import React from 'react';
import { DefaultInput } from './StyledInput';

export const PasswordInput = React.forwardRef((props, ref) => (
  <DefaultInput placeholder="Пароль" type="password" {...props} ref={ref} />
));

export default PasswordInput;
